import { memo } from 'react';
import {
  UserOutlined, TeamOutlined, EyeOutlined,
  LineChartOutlined, BarChartOutlined,
} from '@ant-design/icons';
import MetricCard from '../../../../../components/sharedcomponents/MetricCard';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';
import AnimatedDuration from '../../../../../components/sharedcomponents/Animations/AnimatedDuration';

interface OverviewData {
  activeUsers: string;
  sessions: string;
  pageViews: string;
  bounceRate: number;
  avgSessionDuration: number;
}

interface OverviewTabProps {
  data: OverviewData | null;
}

const OverviewTab = memo(({ data }: OverviewTabProps) => {
  const ov = data ?? {
    activeUsers: '0',
    sessions: '0',
    pageViews: '0',
    bounceRate: 0,
    avgSessionDuration: 0,
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
      <MetricCard
        icon={<UserOutlined />}
        label="Utilisateurs Actifs"
        colorClass="from-blue-700 to-blue-500"
        value={<AnimatedCounter end={parseInt(ov.activeUsers) || 0} duration={1500} />}
      />
      <MetricCard
        icon={<TeamOutlined />}
        label="Sessions"
        colorClass="from-blue-600 to-blue-400"
        value={<AnimatedCounter end={parseInt(ov.sessions) || 0} duration={1800} />}
      />
      <MetricCard
        icon={<EyeOutlined />}
        label="Pages Vues"
        colorClass="from-orange-600 to-orange-400"
        value={<AnimatedCounter end={parseInt(ov.pageViews) || 0} duration={2000} />}
      />
      <MetricCard
        icon={<LineChartOutlined />}
        label="Taux de Rebond"
        colorClass="from-orange-500 to-orange-300"
        value={
          <AnimatedCounter end={Math.round(ov.bounceRate) || 0} suffix="%" duration={1200} />
        }
      />
      <MetricCard
        icon={<BarChartOutlined />}
        label="Durée Moyenne"
        colorClass="from-sky-500 to-cyan-400"
        value={<AnimatedDuration seconds={ov.avgSessionDuration || 0} duration={1600} />}
      />
    </div>
  );
});

OverviewTab.displayName = 'OverviewTab';

export default OverviewTab;